export class ZipDownload {
  filename: string
  body: ArrayBuffer

  constructor(filename: string, body: ArrayBuffer) {
    this.filename = filename
    this.body = body
  }
}



// WEBPACK FOOTER //
// ./src/app/main/models/zip-download.ts